const trim = (value) => {
  return String(value).replace(/^\s+|\s+$/igm, '');
};

export default trim;
